import axios from "axios/dist/axios.js";
import Vue from "vue/dist/vue.js";

function initFeedbackWall() {
	new Vue({
		el: "#feedback-wall__feedback",
		data: {
			data: null,
			isLoading: false,
			page: 1,
      feedback_wall_categories: [],
			totalPages: null,
			dotsLeft: true,
			dotsRight: true,
			isEmpty: false,
			totalPosts: 0,
		},
		mounted() {
      this.getFeedbackWallSettings();
      this.getCurrentLang();
			this.fetchPosts();
		},
		watch: {
      feedback_wall_categories() {
				this.page = 1;
				this.fetchPosts();
      },
		},
		methods: {
			scrollToTop,
			changePage,
			setPageArrow,
			hideThis,
			fetchPosts() {
				this.isLoading = true;
				this.isEmpty = false;
				axios
					.get("/wp-json/wp/v2/" + this.feedbackWallSettings.post_type, {
						params: {
              _fields: "title,content,acf," + this.feedbackWallSettings.category_slug,
              lang: this.currentLang,
							page: this.page,
              per_page: this.feedbackWallSettings.posts_per_page,
              [this.feedbackWallSettings.category_slug]: this.feedback_wall_categories,
						},
					})
					.then((response) => {
						this.totalPages = +response.headers["x-wp-totalpages"];
						this.totalPosts = +response.headers["x-wp-total"];
						if (response.data == "") {
							this.isEmpty = true;
						}
						this.data = response.data;
						this.isLoading = false;
					})
					.catch((error) => {
						console.error(error.response);
					});
			},
      changeCat (event) {
        if (event.target.value == "all") {
          this.feedback_wall_categories = [];
        } else if (this.feedback_wall_categories.includes(Number(event.target.value))) {
          this.feedback_wall_categories = [];
        } else {
          this.feedback_wall_categories = [Number(event.target.value)];
        }
        this.page = 1;
        this.fetchPosts();
      },
			formatCat(categories) {
				if (categories && categories.length > 0) {          
					return categories.toUpperCase();
				} else {
					return "";
				}
			},
			removeData() {
        this.feedback_wall_categories = [];
				this.fetchPosts();
			},
      getFeedbackWallSettings() {
        const element = document.getElementById('feedback-wall__results');
        if (element) {
            const settings = element.dataset.feedbackWallSettings;
            this.feedbackWallSettings = JSON.parse(settings);
        }
      },
      getCurrentLang() {
        this.currentLang = document.documentElement.lang || 'fi';
      
        if (this.currentLang === 'en-GB') {
          this.currentLang = 'en';
        } else if (this.currentLang === 'sv-SE') {
          this.currentLang = 'sv';
        }
      }
		},
	});
}

function scrollToTop() {
  const contentWrapper = this.$el.querySelector("[id*='__results']");
  if (!contentWrapper) return;

  // Make the content wrapper focusable, focus it and then make it unfocusable again.
  contentWrapper.tabIndex = 0;
  contentWrapper.focus();
  contentWrapper.tabIndex = -1;

  // Scroll to the top of the content container, with an offset.
  const contentTop = contentWrapper.getBoundingClientRect().top;
  const contentTopOffset = 200;
  const offsetHeight = contentTop + window.pageYOffset - contentTopOffset;
  window.scrollTo({
    top: offsetHeight,
    behavior: "smooth",
  });
}

function changePage(setPage) {
  this.page = setPage;
  this.dotsRight = true;
  this.dotsLeft = true;
  this.fetchPosts();
  this.scrollToTop();
  this.hideThis();
}

function setPageArrow(setPage) {
  this.page += setPage;
  this.dotsRight = true;
  this.dotsLeft = true;
  this.fetchPosts();
  this.scrollToTop();
  this.hideThis();
}

function hideThis(pageNumber) {
  if (pageNumber === 1 || pageNumber === this.totalPages) {
    return false;
  }
  if (this.page + 1 < pageNumber) {
    this.dotsRight = false;
    return true;
  }
  if (this.page - 1 > pageNumber) {
    this.dotsLeft = false;
    return true;
  }
  return false;
}

function reinitializeVue() {
  const vueRoot = document.querySelector("#feedback-wall__feedback");
  if (vueRoot && !vueRoot.__vue__) {
      initFeedbackWall();
  }
}

// Initial load
document.addEventListener("DOMContentLoaded", reinitializeVue);